import { render, staticRenderFns } from "./saleOrderDispatch.vue?vue&type=template&id=21704f03&scoped=true"
import script from "./saleOrderDispatch.vue?vue&type=script&lang=js"
export * from "./saleOrderDispatch.vue?vue&type=script&lang=js"
import style0 from "./saleOrderDispatch.vue?vue&type=style&index=0&id=21704f03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21704f03",
  null
  
)

export default component.exports